// Namespace "public" — fragment "giftcard" (BUG-020).
//
// THE WORDING IS LOAD-BEARING, not decoration, and it differs from the promo fragment in
// exactly the way the two things differ: a promo changes the PRICE, a card changes WHO
// PAYS it. Nothing here ever says "discount", and nothing here states a new price.
//
// `giftcard.covers` states an EXACT covered amount and an APPROXIMATE residual ("about"),
// because that is the truth of the widget: the covered part is the card's own balance,
// which the quote read; the residual is computed against the price this page displays,
// while the checkout charges the TAXED total, which only the server computes. Promising
// an exact "left to pay" would be a number the payment page then contradicts.
//
// `giftcard.minimumResidual` is the one piece of arithmetic the buyer must see BEFORE
// paying. Stripe refuses any charge under CA$0.50, so a card that would leave 30¢ has its
// application capped at "total − 0.50" and the last cents STAY ON THE CARD. Said here, it
// is a rule; discovered on the payment page, it is a surprise about money.
//
// `giftcard.invalid` and `giftcard.empty` are the only two refusals. They map the
// server's stable answers (404 unknown / not spendable), which deliberately do not say
// WHICH card state is at fault — enumerating a practice's live codes is not something a
// public endpoint may help a stranger do.
export default {
  fr: {
    "giftcard.label": "Carte-cadeau",
    "giftcard.placeholder": "Ex. GC-ABCD123456",
    "giftcard.apply": "Utiliser",
    "giftcard.remove": "Retirer",
    "giftcard.checking": "Vérification…",
    "giftcard.covers": "couvre {covered} · environ {due} à payer",
    "giftcard.balance": "solde {value} · appliqué au paiement",
    "giftcard.minimumResidual":
      "Un minimum de {value} reste à payer par carte bancaire ; le reliquat demeure sur la carte-cadeau.",
    "giftcard.invalid": "Cette carte-cadeau est introuvable.",
    "giftcard.empty": "Cette carte-cadeau n'a plus de solde utilisable.",
  },
  en: {
    "giftcard.label": "Gift card",
    "giftcard.placeholder": "e.g. GC-ABCD123456",
    "giftcard.apply": "Use",
    "giftcard.remove": "Remove",
    "giftcard.checking": "Checking…",
    "giftcard.covers": "covers {covered} · about {due} left to pay",
    "giftcard.balance": "balance {value} · applied at payment",
    "giftcard.minimumResidual":
      "A minimum of {value} is still charged to a bank card; the remainder stays on the gift card.",
    "giftcard.invalid": "This gift card could not be found.",
    "giftcard.empty": "This gift card has no spendable balance left.",
  },
  es: {
    "giftcard.label": "Tarjeta de regalo",
    "giftcard.placeholder": "Ej. GC-ABCD123456",
    "giftcard.apply": "Usar",
    "giftcard.remove": "Quitar",
    "giftcard.checking": "Verificando…",
    "giftcard.covers": "cubre {covered} · unos {due} por pagar",
    "giftcard.balance": "saldo {value} · aplicado en el pago",
    "giftcard.minimumResidual":
      "Se cobra un mínimo de {value} a una tarjeta bancaria; el resto permanece en la tarjeta de regalo.",
    "giftcard.invalid": "No se ha encontrado esta tarjeta de regalo.",
    "giftcard.empty": "Esta tarjeta de regalo ya no tiene saldo disponible.",
  },
};
